import Modal from "components/elements/Modal";
import classes from "./classes.module.scss";
import Typography from "components/elements/Typography";
import I18n from "components/materials/I18n";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { useCallback } from "react";
import Button, { EButtonColor, EButtonVariant } from "components/elements/Button";
import MediaResponseResource from "common/resources/Project/Config/Media/MediaResponseResource";
import { translateISO369 } from "utils/I18nText";
import MediaService from "services/projects/MediaService";
import { container } from "tsyringe";

const mediaService = container.resolve(MediaService);

type IProps = {
	projectId: string;
	isOpen: boolean;
	media: MediaResponseResource;
	onClose: () => void;
	onDeletedMedia: (deletedId: string) => void;
};

export default function DeleteMediaModal(props: IProps) {
	const onDeleteMedia = useCallback(() => {
		mediaService.delete(props.projectId, props.media.id).then(() => {
			props.onDeletedMedia(props.media.id);
		});
	}, [props]);

	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} className={classes["root"]}>
			<div className={classes["header"]}>
				<Typography type="p" size="large" weight="bold">
					{I18n.asset.pages.professional_space.tabs.media.delete_media_modal.title}
				</Typography>
				<XMarkIcon className={classes["icon"]} onClick={props.onClose} />
			</div>

			<div className={classes["text-container"]}>
				<Typography type="p">
					{I18n.trslt(I18n.asset.pages.professional_space.tabs.media.delete_media_modal.text_1, {
						name: props.media.caption ? (translateISO369(props.media.caption) ?? "") : "",
					})}
				</Typography>
				<Typography type="p">{I18n.asset.pages.professional_space.tabs.media.delete_media_modal.text_2}</Typography>
			</div>

			<div className={classes["buttons-container"]}>
				<Button variant={EButtonVariant.TEXT} color={EButtonColor.PRIMARY} onClick={props.onClose}>
					{I18n.asset.pages.professional_space.tabs.media.delete_media_modal.cancel}
				</Button>
				<Button variant={EButtonVariant.CONTAINED} color={EButtonColor.PRIMARY} onClick={onDeleteMedia}>
					{I18n.asset.pages.professional_space.tabs.media.delete_media_modal.confirm}
				</Button>
			</div>
		</Modal>
	);
}
